import { z } from "zod";
import { ShiftPosition } from "@/types/schemas";
import { ProjectVenueType } from "@/types/db/projects";

type Json = Record<string, any>;

export type ProjectForm = {
  name: string;
  client_id: string;
  client_name?: string;
  location_id?: string;
  requested_by?: string;
  primary_contact?: string;
  onsite_contact?: string;
  comments?: Json;
  status?: string;
  meta_data?: Json & {
    status?: string;
    abilities?: string[];
    restrictions?: string[];
    venue_type?: ProjectVenueType;
    dress_code_id?: string;
    markets?: string[];
  };
};

export type Position = Partial<z.infer<typeof ShiftPosition>> & {
  position_id?: string; // FK to lists.positions
  location_override?: {
    inherit: boolean;
    location?: any; // only used when inherit = false
  };
};

export type MealOption = {
  type: "UNPAID" | "PAID";
  paid_by?: "CLIENT" | "TENANT";
  duration: number; // in minutes
  after: number; // hours after shift start when break begins
};

export type ShiftForm = {
  name?: string | null;
  description?: string | null;
  start_time?: string | null;
  end_time?: string | null;
  comments?: Json;
  positions: Position[];
  meta_data?: Json & {
    location?: any;
    meal_option?: MealOption[];
  };
};

export type ProjectPayload = { project: ProjectForm; shifts: ShiftForm[] };
